import React from 'react'
import {
  Filter,
  FilterComponent,
  FilterOption
} from '../_WMS/FilterComponent'
import { FilterExtraAction } from '../_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  }
]

interface ProductSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  extraActions?: FilterExtraAction[]
}

export const SettingsSearch: React.FC<ProductSearchProps> = (props) => {
  return (
    <FilterComponent
      options={filterOptions}
      {...props}
      selectedFilters={props.selectedFilters}
      extraActions={props.extraActions}
      includeSearchOnClean={true}
      defaultSelectedFilterKey='productOriginId'
    />
  )
}
